
import React from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface GuestNamePromptProps {
  username: string;
  setUsername: (value: string) => void;
  handleUsernameSubmit: (e: React.FormEvent) => void;
}

const GuestNamePrompt: React.FC<GuestNamePromptProps> = ({
  username,
  setUsername,
  handleUsernameSubmit
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Welcome to the Group Chat</h3>
      <p className="mb-4">Please enter your name to continue:</p>
      <form onSubmit={handleUsernameSubmit} className="space-y-4">
        <Input
          placeholder="Your name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoFocus
        />
        <Button type="submit" className="w-full">
          Continue to Chat
        </Button>
      </form>
    </Card>
  );
};

export default GuestNamePrompt;
